//const environment = "DEV_LOCAL";
//const environment = "DEV";
//const environment = "PREPROD";
const environment = "PRODUCTION";

let urlApi = "";

// Detectar si estamos en localhost o en un dominio externo
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

if (environment === 'DEV') {
    urlApi = 'https://cobrosapp.seguroselroble.com/';
}
else if (environment === 'DEV_LOCAL') {
    // En localhost usar ruta relativa para el proxy de webpack
    // En dominios externos usar la URL completa del backend
    urlApi = isLocalhost ? '/' : 'https://cobrosappdev.backend.com/';
}
else if(environment === 'PRODUCTION') {
    urlApi = 'https://cobrosapp.elroble.com/';
}
else if(environment === 'PREPROD') {
    urlApi = 'https://cobrosapppreprod.seguroselroble.com/';
}

export const CONFIG = {
    defaultLang: 'es',
    apiUrl: urlApi,
    getWsUrl: function (endpoint) {
        return urlApi + endpoint
    },
    localStorageDisk: 'ElRobleApp',
    getEnvironment: function () {
        return environment;
    },
    getVersion: function () {
        return "2.0.1";
    }
};

